import { useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Container, ContainerAcessos, Titulo } from "./styles.js";
import axios from "axios";
import { apiUrl } from "../../../services/api.js";
import { useAuth } from "../../../contexts/auth";


const VerifyPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { buscaUser } = useAuth();

  const verifyLink = useCallback(
    async (email, token) => {
      try {
        const response = await axios.get(
          `${apiUrl}/usuarios/verifyToken?email=${email}&token=${token}`
        );

        if (response.data.return) {
          const userData = {
            mensagem: response.data.mensagem,
            id_usuario: response.data.id_usuario,
            usuario: response.data.usuario,
            nome: response.data.nome,
            email: response.data.email,
            perfil: response.data.perfil,
            permissao: response.data.permissao,
            status: response.data.status,
            dois_fatores: response.data.dois_fatores,
            data_oferecimento_avaliacao: response.data.data_oferecimento_avaliacao,
            token: response.data.token,
          };

          localStorage.setItem("userSistema", JSON.stringify(userData));

          buscaUser();

          toast.success(response.data.mensagem);
          history.push("/home");
        } else {
          toast.error("Invalid or expired token.");
        }
      } catch (error) {
        console.error("Error verifying link:", error);
        toast.error("Failed to verify token.");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");
    const token = queryParams.get("token");

    if (email && token) {
      verifyLink(email, token);
    } else {
      toast.error("Invalid verification link.");
    }
  }, [location, verifyLink]);

  return (
    <Container>
      <ContainerAcessos>
        <Titulo>Carregando...</Titulo>
      </ContainerAcessos>
    </Container>
  );
};

export default VerifyPage;
